export default () => ({
    show: false,
    loading: false,
    checkout: false,
    activeOption: null,
    toggle () {
        this.show = !this.show;
        Grebify.noScroll(this.show);
    },

    setOption(optionValue) {
        const wrapper = this.$refs.inputWrapper;
        
        Array.from(wrapper.children).forEach(element => {
            let input = element.firstElementChild.firstElementChild;
            if(input.id == optionValue) {
                let span = input.nextElementSibling; 
                span.classList.add('bg-green');
                // this.activeOption = span.dataset.name;
                // this.$dispatch('set-option-text', this.activeOption);
            } else {
                input.nextElementSibling.classList.remove('bg-green');
            }
        });
    },

    initOption() {
        if (window.location.href.indexOf("?sort_by=") > -1) {
            const url = window.location.href;
            const char = "?sort_by=";
            const result = url.substring(url.indexOf(char) + char.length);
            
            const wrapper = this.$refs.inputWrapper;
        
            Array.from(wrapper.children).forEach(element => {
                let input = element.firstElementChild.firstElementChild;
                if(input.id == result) {
                    let span = input.nextElementSibling; 
                    span.classList.add('bg-green');
                    this.activeOption = span.dataset.name;
                    this.$dispatch('set-option-text', this.activeOption);
                } else {
                    input.nextElementSibling.classList.remove('bg-green');
                }
            });

        }
        
    }
});